import React from 'react'
import moize from 'moize'

import styles from './style.module.css'

const Loading = ({ disable }) => {
  if (disable) return null
  return (
    <div className={styles['loading']}>
      <div className={styles['loading-bar']}></div>
    </div>
  )
}

export default moize(Loading, {
  isReact: true,
})
